'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixCustomClassNames = exports.isFormValid = exports.validateForm = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _validators = require('./validators');

var _validators2 = _interopRequireDefault(_validators);

var _logging = require('./logging');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validateForm = exports.validateForm = function validateForm(formData, formConfig) {

  var errors = {};

  formConfig.forEach(function (fieldConfig) {

    if (fieldConfig.customComponent) {
      return;
    }

    var shouldValidate = fieldConfig.type !== 'button' && (fieldConfig.shouldValidate === undefined || fieldConfig.shouldValidate(formData));

    if (shouldValidate) {
      if (!errors[fieldConfig.name]) {
        errors[fieldConfig.name] = [];
      }

      var value = _lodash2.default.get(formData, fieldConfig.name);

      if (value === undefined) {
        (0, _logging.warn)('Not found element in form:', fieldConfig.name);

        errors[fieldConfig.name].push('Errore imprevisto');
        return;
      }

      if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {

        var atLeastOneValidItem = false;

        fieldConfig.items.forEach(function (itemConfig) {

          var isRequired = typeof itemConfig.isRequired !== 'boolean' || itemConfig.isRequired;
          var itemValue = _lodash2.default.get(formData, itemConfig.name);
          var format = itemConfig.format || fieldConfig.format || 'string';

          if (typeof format === 'function') {
            /* If format is a function, when called it should return a string or a falsy value. */
            format = format(formData);
          }

          var isValid = !format || _validators2.default[format](itemValue);

          atLeastOneValidItem = atLeastOneValidItem || !!(isValid && itemValue);

          /* If value is not set, we will give an error only if isRequired. */
          if (!isValid && (itemValue || isRequired)) {

            var label = itemConfig.leftLabel || itemConfig.rightLabel || itemConfig.label || fieldConfig.label || fieldConfig.bigLabel;

            (0, _logging.warn)('Not valid (1):', { label: label, name: itemConfig.name, format: format, itemValue: itemValue });

            /* Adding the error in parent field's errors list. */
            errors[fieldConfig.name].push(label + ': ' + _validators2.default[format].errorMessage);
          }
        });

        if (fieldConfig.isRequired && !atLeastOneValidItem) {

          (0, _logging.warn)('Not valid (2):', fieldConfig.name);

          errors[fieldConfig.name].push(_validators2.default[fieldConfig.items[0].format].errorMessage);
        }
      } else {

        var format = fieldConfig.format || 'string';

        //console.log('Field config', fieldConfig.name, format, value);

        var isRequired = typeof fieldConfig.isRequired !== 'boolean' || fieldConfig.isRequired;

        var isValid = !format || _validators2.default[format](value);

        if (!isValid && (value || isRequired)) {

          (0, _logging.warn)('Not valid (3)', { name: fieldConfig.name, format: format, value: value });

          errors[fieldConfig.name].push(_validators2.default[format].errorMessage);
        }
      }
    }
  });

  return errors;
};

var isFormValid = exports.isFormValid = function isFormValid(errorsMap) {

  return _lodash2.default.values(errorsMap).reduce(function (prev, current) {
    return prev && current.length === 0;
  }, true);
};

var fixCustomClassNames = exports.fixCustomClassNames = function fixCustomClassNames(customClassNames) {

  var fixedCustomClassNames = customClassNames || [];

  if (typeof customClassNames === 'string') {
    fixedCustomClassNames = customClassNames.split(' ');
  }
  return fixedCustomClassNames;
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/arreeba-form/lib/lib/utils.js
// module id = 79
// module chunks = 0